<template>
    <div class="nav-sidebar__wrapper">
        <SimpleBannerContainer
            :banners="skyscraperBanners"
            :type="bannerCategory"
            class="banner__container--skyscraper"
        />
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import SimpleBannerContainer from '@app/modules/shared/banners/SimpleBannerContainer.vue';
    import { BannerCategory } from '@core/models/banners/enums';

    export default {
        name: 'NewsSidebar',
        data() {
            return {
                bannerCategory: BannerCategory.skyscrapers,
            };
        },
        created() {
            // this.fetchSkyscraperBanners();
        },
        methods: {
            ...mapActions('data/banners', [
                'fetchSkyscraperBanners',
            ]),
        },
        computed: {
            ...mapGetters('data/banners', [
                'skyscraperBanners',
            ]),
        },
        components: {
            SimpleBannerContainer,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/results/leftSidebar/SpecialsSidebar.vue